var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var InterventionNavListItem = require('./interventionNavListItem.jsx');

var InterventionNavList = createReactClass({
    mixins: [PureRenderMixin],

	render: function(){
        var interventionNavNodes = this.props.interventions.map(function(intervention, i){
            // shouldn't show invalid intervention
            if(intervention.isSponsored && !intervention.sponsoredPlacement.webTag){
                return null;
            }else{
                return (
                    <InterventionNavListItem
                        intervention={intervention}
                        key={i}
                        clickTracking={this.props.clickTracking}
                        onSponsoredPlacementChange={this.props.onSponsoredPlacementChange} />
                );
            }
        }.bind(this));

		return (
            <ul className="intervention-nav-list no-bullet clearfix">
                {interventionNavNodes}
            </ul>
	    )
	}
});

module.exports = InterventionNavList;



// WEBPACK FOOTER //
// ./src/common/routes/conditions/components/layout/interventionNavList.jsx